import React from "react";
import { useIntl } from "react-intl";
import { useFormikContext } from "formik";
import { Row, Space, Button, Badge, Form } from "@masterteam/mt-design-react";

import { ReactComponent as RemoveIcon } from "../../assets/images/close.svg";

const { Field } = Form;

function ParameterItem({ index, removeItem, errors, isEditMode, isReadOnly }) {
  const intl = useIntl();
  const { setFieldValue, values } = useFormikContext();

  return (
    <Row size="small" align="center">
      <Badge variant="dark" shape="circle">
        {index + 1}
      </Badge>

      <div style={{ flex: 1 }}>
        <Field
          name={`Parameters[${index}].ParameterName`}
          label={intl.formatMessage({ id: "kpi.parameter-name" })}
          disabled={isEditMode || isReadOnly}
          inputProps={{
            placeholder: intl.formatMessage({ id: "kpi.parameter-name" }),
            error: errors?.ParameterName,
            onChange: (e) => {
              setFieldValue(
                `Parameters[${index}].ParameterName`,
                e.target.value
              );
              setFieldValue("Formula", []);
            },
          }}
          hideErrorMessage
        />
      </div>

      <div style={{ flex: 2 }}>
        <Field
          label={intl.formatMessage({
            id: "kpi.parameter-description",
          })}
          name={`Parameters[${index}].Description`}
          disabled={isEditMode || isReadOnly}
          inputProps={{
            placeholder: intl.formatMessage({
              id: "kpi.parameter-description",
            }),
            error: errors?.Description,
          }}
          hideErrorMessage
        />
      </div>

      <Button
        shape="square"
        fill="none"
        variant="error"
        tooltip-position="top"
        tooltip={intl.formatMessage({ id: "common.delete" })}
        Icon={RemoveIcon}
        disabled={isEditMode || isReadOnly}
        onClick={() => removeItem(index)}
      />
    </Row>
  );
}

export default ParameterItem;
